<template>
    <b-table hover small responsive show-empty class="sr-caption"
             aria-live="polite"
             :id="slug"
             :fields="fields"
             :items="items"
             primary-key="id"
             :busy="isLoading"
             label-sort-asc=""
             label-sort-desc=""
             sort-by="endDate"
             sort-desc="true"
             caption="Employment History Table. To sort data in this table click on the field in the header. Click again to sort descending.">
        <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:empty="scope">
            <p>No employment history found.</p>
        </template>
        <template v-slot:cell(startDate)="row">
            {{formatDate(row.item.startDate)}}
        </template>
        <template v-slot:cell(endDate)="row">
            {{formatDate(row.item.endDate)}}
        </template>
        <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                       label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
            <strong>Loading, Please Wait...</strong>
        </div>
    </b-table>
</template>

<script>
    import moment from 'moment';
    export default {
        name: "EmploymentHistoryTableList",
        components: {},
        props: {
            items: Array,
            slug: [String],
            isLoading: Boolean,
        },
        data: () => ({
            fields: [
                {key: 'name', sortable: true, label: 'Employer Name'},
                {key: 'address.streetAddress', sortable: true, label: 'Address'},
                {key: 'address.city', sortable: true, label: 'City'},
                {key: 'address.state', sortable: true, label: 'State'},
                {key: 'address.postalCode', sortable: true, label: 'Zip'},
                {key: 'startDate', sortable: true, label: 'Start Date'},
                {key: 'endDate', sortable: true, label: 'End Date'},
            ]
        }),
        methods:{
            formatDate(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY")
            },
        }

    }
</script>

<style scoped>

</style>